export default {
    LOAD_RESPOND: 'loadRespond'
};